import { BookOne } from "../components/feature/serviceBook";
export default function BookServicePage() {
  return (
   <section className="px-5 py-5 md:px-10 xl:px-14 md:py-10">
     <BookOne/>
   </section>
  );
}
